<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span>{{ this.mng_ranking_title }}</span>
</div>

<tb-header parentPage="rankingMngSection"></tb-header>

<div class="contentGlobal">
    <div style="display: flex; justify-content: center; flex-wrap: wrap">
        <div>
            <mat-card class="fuse-card-grid">
                <mat-card-header>
                    <mat-card-title translate>{{ mng_ranking_title }}</mat-card-title>
                </mat-card-header>
                <div style="display: flex; justify-content: space-between">
                    <div class="inputSearchStyle">
                        <mat-form-field appearance="outline">
                            <mat-label translate>ON_PREMISE_SECTION.SEARCH_ONPREMISE</mat-label>
                            <mat-icon matPrefix [inline]="true">search</mat-icon>
                            <input
                                [(ngModel)]="search"
                                (click)="applyFilter($event)"
                                (keyup)="applyFilter($event)"
                                type="text"
                                matInput
                                [matAutocomplete]="auto"
                            />
                            <mat-icon matSuffix [inline]="true" (click)="clearSearch()" class="pointer">highlight_off</mat-icon>
                            <mat-autocomplete
                                #auto="matAutocomplete"
                                (optionSelected)="onIndustrySelected($event)"
                                [displayWith]="displayFn"
                            >
                                <mat-option *ngFor="let istance of filteredInstance" [value]="istance">
                                    {{ istance }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="inputSearchStyle" style="margin-left: 10px" *ngIf="newInfo">
                        <mat-form-field appearance="outline">
                            <mat-label translate>COMMONS.SEARCH</mat-label>
                            <mat-icon matPrefix [inline]="true">search</mat-icon>
                            <input
                                [(ngModel)]="searchInfo"
                                (click)="applyGenericFilter($event)"
                                (keyup)="applyGenericFilter($event)"
                                type="text"
                                matInput
                            />
                            <mat-icon matSuffix [inline]="true" (click)="clearSearchInfo()" class="pointer">highlight_off</mat-icon>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="infoFound; else other_content" class="table-style">
                    <table mat-table id="subscriptionsTable" [dataSource]="dataSourceNewInfo" multiTemplateDataRows style="width: 100%">
                        <ng-container matColumnDef="Expand">
                            <th mat-header-cell *matHeaderCellDef aria-label="row actions"></th>
                            <td mat-cell *matCellDef="let element" class="functionality-field-group">
                                <button mat-icon-button aria-label="expand row" (click)="onRowClicked(element)">
                                    <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                                    <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Ranking">
                            <th mat-header-cell *matHeaderCellDef class="header-cell">
                                <span translate>COMMONS.RANKING</span>
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                                    <mat-icon matPrefix [inline]="true">filter_alt</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button
                                        mat-menu-item
                                        *ngFor="let ranking of rankingListAvailable"
                                        (click)="applyColumnFilter('ranking', ranking)"
                                    >
                                        <span translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </span> {{ ranking }}
                                    </button>
                                    <button mat-menu-item (click)="applyColumnFilter('none')">
                                        <span translate>COMMONS.RESTORE</span>
                                    </button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" upperCase>{{ element.Ranking }}</td>
                        </ng-container>
                        <ng-container matColumnDef="DbSize">
                            <th mat-header-cell *matHeaderCellDef class="header-cell">
                                <span translate>COMMONS.DATABASE_SIZE</span>
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                                    <mat-icon matPrefix [inline]="true">filter_alt</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button
                                        mat-menu-item
                                        *ngFor="let dbsize of dbSizeListAvailable"
                                        (click)="applyColumnFilter('dbsize', dbsize)"
                                    >
                                        <span translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </span> {{ getDBSizeDescription(dbsize) }}
                                    </button>
                                    <button mat-menu-item (click)="applyColumnFilter('none')">
                                        <span translate>COMMONS.RESTORE</span>
                                    </button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" upperCase>{{ getDBSizeDescription(element.DbSize) }}</td>
                        </ng-container>
                        <ng-container matColumnDef="NrCal">
                            <th mat-header-cell *matHeaderCellDef class="header-cell">
                                <span translate>COMMONS.NR_CALS</span>
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                                    <mat-icon matPrefix [inline]="true">filter_alt</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item *ngFor="let nrCal of nrCalAvailable" (click)="applyColumnFilter('nrCal', nrCal)">
                                        <span translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </span> {{ nrCal }}
                                    </button>
                                    <button mat-menu-item (click)="applyColumnFilter('none')">
                                        <span translate>COMMONS.RESTORE</span>
                                    </button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" upperCase>{{ element.NrCal }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Country">
                            <th mat-header-cell *matHeaderCellDef class="header-cell">
                                <span translate>COMMONS.COUNTRY</span>
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="menu">
                                    <mat-icon matPrefix [inline]="true">filter_alt</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button
                                        mat-menu-item
                                        *ngFor="let country of countriesAvailable"
                                        (click)="applyColumnFilter('country', country)"
                                    >
                                        <span translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </span> {{ country }}
                                    </button>
                                    <button mat-menu-item (click)="applyColumnFilter('none')">
                                        <span translate>COMMONS.RESTORE</span>
                                    </button>
                                </mat-menu>
                            </th>
                            <td mat-cell *matCellDef="let element" upperCase>{{ element.Country }}</td>
                        </ng-container>
                        <ng-container matColumnDef="SubscriptionKey">
                            <th mat-header-cell *matHeaderCellDef class="header-cell">
                                <span translate>Subscription key</span>
                            </th>
                            <td mat-cell *matCellDef="let element" upperCase>{{ element.SubscriptionKey }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Description">
                            <th mat-header-cell *matHeaderCellDef class="header-cell">
                                <span translate>Description</span>
                            </th>
                            <td mat-cell *matCellDef="let element" upperCase>{{ element.Description }}</td>
                        </ng-container>
                        <ng-container matColumnDef="Note">
                            <th mat-header-cell *matHeaderCellDef class="header-cell">
                                <span translate>COMMONS.NOTES</span>
                            </th>
                            <td mat-cell *matCellDef="let element" upperCase>{{ element.Note }}</td>
                        </ng-container>
                        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                        <ng-container matColumnDef="expandedDetail">
                            <td
                                mat-cell
                                class="td-detail"
                                *matCellDef="let element; let index = dataIndex"
                                [attr.colspan]="displayedColumnsSubscriptions.length"
                            >
                                <div
                                    class="element-detail"
                                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
                                    style="display: flex; flex-direction: column"
                                >
                                    <div style="display: flex; flex-direction: column; justify-content: flex-start">
                                        <div style="padding-left: 0.8rem; padding-top: 0.8rem; padding-right: 0.8rem; padding-bottom: 0rem">
                                            <h5>
                                                <span translate>COMMONS.USER</span>: {{ this.companyName }}
                                                <span *ngIf="existUserID"
                                                    >(<span translate>COMMONS.USER_CODE</span>: {{ this.userId }})</span
                                                >
                                            </h5>
                                        </div>
                                        <div style="padding-left: 0.8rem; padding-top: 0rem; padding-right: 0.8rem; padding-bottom: 0.1rem">
                                            <span translate class="text-bold">COMMONS.PARTNER_REFERENCE</span>:
                                            <span *ngIf="resellerCompanyName; else showOnlyPartnerCode">
                                                {{ resellerCompanyName }} (<span translate>PARTNERSLIST_SECTION.PARTNER_CODE</span>:
                                                {{ this.partnerCode }})
                                            </span>
                                            <ng-template #showOnlyPartnerCode>
                                                <span>
                                                    {{ this.partnerCode }}
                                                </span>
                                            </ng-template>
                                        </div>
                                        <div style="padding-left: 0.8rem; padding-top: 0rem; padding-right: 0.8rem; padding-bottom: 0.1rem">
                                            <span translate class="text-bold">COMMONS.FRAGMENT</span>:{{ element.Fragment }}
                                        </div>
                                        <div style="display: flex; flex-direction: row; padding: 0.8rem">
                                            <div style="max-width: 100px; padding-right: 0.8rem">
                                                <mat-form-field appearance="outline">
                                                    <mat-label translate>COMMONS.RANKING</mat-label>
                                                    <!-- uno dei due [(value)] va tolto -->
                                                    <mat-select [(value)]="ranking">
                                                        <mat-option *ngFor="let ranking of rankings" [(value)]="ranking.value">
                                                            {{ ranking.viewValue }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div style="flex-grow: 8; padding-right: 0.8rem">
                                                <mat-form-field appearance="outline">
                                                    <mat-label translate>COMMONS.NOTES</mat-label>
                                                    <input matInput [(ngModel)]="note" name="Note" type="text" />
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display: flex; justify-content: flex-end">
                                        <div>
                                            <button mat-flat-button color="primary" [disabled]="false" (click)="save(element)">
                                                <span translate>B_SAVE</span>
                                            </button>
                                        </div>
                                        <div>
                                            <button mat-flat-button color="primary" (click)="onRowClicked(element)">
                                                <span translate>B_CANCEL</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsSubscriptions"></tr>
                        <tr
                            mat-row
                            *matRowDef="let element; columns: displayedColumnsSubscriptions"
                            class="element-row"
                            [class.expanded-row]="expandedElement === element"
                            (click)="!element.isFakeData ? onRowClicked(element) : 'nothing'"
                        ></tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
                    </table>
                    <div class="message-box info margin-top-1-25rem">
                        <span>
                            {{ mng_ranking_infoDbSize }}
                        </span>
                        <br />
                        <span>
                            {{ mng_ranking_infoRanking }}
                        </span>
                        <br />
                        <span>
                            {{ mng_ranking_infoRanking_2 }}
                        </span>
                    </div>
                    <mat-paginator
                        #subscriptionsPaginator
                        *ngIf="infoFound"
                        [pageSizeOptions]="[5, 10, 20]"
                        showFirstLastButtons
                    ></mat-paginator>
                </div>
                <ng-template #other_content>
                    <div class="message-box warning">
                        <mat-label translate *ngIf="!noDataFound">COMMONS.NO_SELECTED_INSTANCE</mat-label>
                        <mat-label translate *ngIf="noDataFound">COMMONS.NO_ELEMENTFOUND</mat-label>
                    </div>
                </ng-template>
            </mat-card>
        </div>
    </div>
    <div *ngIf="loading">
        <tb-loading></tb-loading>
    </div>
</div>
